import React from 'react';
import { FormattedMessage } from 'react-intl';
import { history } from './../../configuration/store';
import AddressList from './../../components/lists/addresses';

class AddressesPage extends React.Component {
    render() {
        return (
            <div className="page">
                <div className="row">
                    <div className="col-xs-12">
                        <h4>{AddressesPage.meta.label}</h4>
                    </div>
                    <div className="col-xs-12">
                        <AddressList />
                    </div>
                </div>
            </div>
        );
    }
}

AddressesPage.meta = {
    label: <FormattedMessage id={'addresses'} defaultMessage={'Addresses'} />,
    icon: 'place',
    action: () => history.push('/addresses'),
    locations: ['/addresses']
};

export default AddressesPage;



// WEBPACK FOOTER //
// ./src/pages/addresses/index.jsx